import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import TaskCategoriesReducer from './taskcategoriesreducer';
import {documentTypes, documentTabLayoutTabs, documentGetAllParamNames} from '../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */

export default function HandOffTaskDocumentReducer(state = initialState.handOffTaskDocuments, action) {
	switch (action.type) {
		case types.GET_TASK_DOCUMENTS: {
			const {
				loggedInUserId,
				taskStatusId,
				isEPSignOffRequired,
				isEPSignOffUserRequired,
				isEQRSignOffRequired,
				isEQRSignOffUserRequired,
				evidences
			} = state;

			let taskDocuments = action.response;
			taskDocuments.initialIsEPSignOffRequired = isEPSignOffRequired;
			taskDocuments.initialIsEQRSignOffRequired = isEQRSignOffRequired;
			taskDocuments.initialIsEPSignOffUserRequired = isEPSignOffUserRequired;
			taskDocuments.initialIsEQRSignOffUserRequired = isEQRSignOffUserRequired;

			const updatedEvidences = [];
			_.forEach(evidences, (evidence) => {
				updatedEvidences.push({...evidence, isPrepRevSignOff: null});
			});
			return {
				...taskDocuments,
				evidences: updatedEvidences,
				//loggedInUserId: loggedInUserId,
				taskStatusId: taskStatusId,
				isEPSignOffRequired: isEPSignOffRequired,
				isEPSignOffUserRequired: isEPSignOffUserRequired,
				isEQRSignOffRequired: isEQRSignOffRequired,
				isEQRSignOffUserRequired: isEQRSignOffUserRequired,
				apiLoaded: true
			};
		}
		case types.GET_EVIDENCES: {
			let evidenceList =
				action.response.data && action.response.data.length ? constructEvidenceList(action, state, 'approvals') : null;

			return {
				...state,
				evidences: evidenceList,
				initialEvidenceCollection: evidenceList,
				apiLoaded: true
			};
		}
		case types.GET_TASK_DETAILS: {
			let taskDetails = action.response;
			const {
				taskStatusId,
				isEPSignoffRequired,
				isEPSignoffUserRequired,
				isEQRSignoffRequired,
				isEQRSignoffUserRequired
			} = taskDetails;
			return {
				...state,
				taskStatusId: taskStatusId,
				isEPSignOffRequired: isEPSignoffRequired,
				isEPSignOffUserRequired: isEPSignoffUserRequired,
				isEQRSignOffRequired: isEQRSignoffRequired,
				isEQRSignOffUserRequired: isEQRSignoffUserRequired,
				initialIsEPSignOffRequired: isEPSignoffRequired,
				initialIsEQRSignOffRequired: isEQRSignoffRequired,
				initialIsEPSignOffUserRequired: isEPSignoffUserRequired,
				initialIsEQRSignOffUserRequired: isEQRSignoffUserRequired
			};
		}
		case types.GET_USER_PREFERENCES: {
			return {
				...state,
				loggedInUserId: action.response.id
			};
		}
		case types.GET_DOCUMENT_LIST: {
			if (action.filters && action.filters.props.documentCategoryName === 'evidence' && action.response?.data) {
				if (action.filters.shared) {
					let apiResponseIsFiltered = false;
					/** when user is searching documents inside task detail/ document section then we don't need to return updated list
					 *  because api response might have less document then actual documents associated with task so we will return existing state with all documents.
					 * searchtype key is available even if we don't search anything because that contain contains or startwith operator so ignoring**/
					Object.keys(action.filters.shared)
						.filter((key) => key !== documentGetAllParamNames.searchType)
						.some((key) => {
							if (!_.isEmpty(action.filters.shared[key])) {
								apiResponseIsFiltered = true;
								return apiResponseIsFiltered;
							}
						});

					if (apiResponseIsFiltered) {
						return state;
					}
				}

				let evidenecList = constructEvidenceList(action, state, 'approvals');

				let result = {
					...state,
					[documentTabLayoutTabs.evidenceName]: evidenecList,
					initialEvidenceCollection: evidenecList,
					apiLoaded: true
				};
				// return Object.assign({}, state)
				return result;
			}
			let result = {
				...state,
				apiLoaded: true
			};
			return result;
		}
		case types.GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY:
			// Only take the fields coming from the API response.
			let taskDocumentsStatusAndFlags = action.response;
			return {
				...state,
				loggedInUserId: taskDocumentsStatusAndFlags.loggedInUserId,
				taskStatusId: taskDocumentsStatusAndFlags.taskStatusId,
				reHandOff: taskDocumentsStatusAndFlags.reHandOff,
				enableHandOff: taskDocumentsStatusAndFlags.enableHandOff,
				enableButton: taskDocumentsStatusAndFlags.enableButton,
				enableHandoffforPgat: taskDocumentsStatusAndFlags.enableHandoffforPgat,
				enableCompleteButton: taskDocumentsStatusAndFlags.enableCompleteButton,
				enableReturned: taskDocumentsStatusAndFlags.enableReturned,
				enableSendButton: taskDocumentsStatusAndFlags.enableSendButton,
				isEPEQRSignoffComplete: taskDocumentsStatusAndFlags.isEPEQRSignoffComplete,
				isEPSignOffRequired: taskDocumentsStatusAndFlags.isEPSignOffRequired,
				isEQRSignOffRequired: taskDocumentsStatusAndFlags.isEQRSignOffRequired,
				isEPSignOffUserRequired: taskDocumentsStatusAndFlags.isEPSignOffUserRequired,
				isEQRSignOffUserRequired: taskDocumentsStatusAndFlags.isEQRSignOffUserRequired,
				isDocumentsInTransit: taskDocumentsStatusAndFlags.istaskDocumentsStatusAndFlagsDocumentsInTransit,
				hasEQRSignOff: taskDocumentsStatusAndFlags.hasEQRSignOff,
				hasEPSignOff: taskDocumentsStatusAndFlags.hasEPSignOff
			};
		case types.UPDATE_EP_SIGNOFFREQUIRED:
			let newStateEPSignOff = {
				...state,
				isEPSignOffUserRequired: action.value
			};
			return newStateEPSignOff;
		case types.UPDATE_EQR_SIGNOFFREQUIRED:
			let newStateEQRSignOff = {
				...state,
				isEQRSignOffUserRequired: action.value
			};
			return newStateEQRSignOff;
		case types.UPDATE_SIGNOFF_INDIVIDUAL_DOCUMENT:
			let newevidences = JSON.parse(JSON.stringify(state.evidences));
			newevidences.map((evidence) => {
				if (evidence.documentId === action.documentId) {
					var updateEvidence = evidence;
					updateEvidence.isPrepRevSignOff = action.approvalType;
					Object.assign({}, updateEvidence);
				}
			});
			return {
				...state,
				evidences: newevidences
			};

		case types.ADD_APPROVAL_FOR_DOCUMENT:
			if (state.evidences) {
				newevidences = JSON.parse(JSON.stringify(state.evidences));
				newevidences.map((evidence) => {
					if (evidence.documentId === action.documentId) {
						var updateEvidence = evidence;
						if (updateEvidence.signOffs) {
							updateEvidence.isPrepRevSignOff = null;
							action.response.id = action.response.approvalId;
							updateEvidence.signOffs.push(action.response);
							// will use signoff list to check if mark complete should enable or disabled
							updateEvidence.enableCompleteButton = undefined;
							Object.assign({}, updateEvidence);
						}
					}
				});
				return {
					...state,
					evidences: newevidences,
					initialEvidenceCollection: newevidences
				};
			}
			return {...state};
		case types.REMOVE_APPROVAL_FOR_DOCUMENT:
			if (state.evidences) {
				newevidences = JSON.parse(JSON.stringify(state.evidences));
				newevidences.map((evidence) => {
					if (evidence.documentId === action.documentId) {
						var updateEvidence = evidence;
						if (evidence.signOffs) {
							updateEvidence.signOffs = evidence?.signOffs.filter((item) => {
								return item.id != action.approvalId;
							});
						}

						updateEvidence.enableCompleteButton = undefined;
						Object.assign({}, updateEvidence);
					}
				});
				return {
					...state,
					evidences: newevidences,
					initialEvidenceCollection: newevidences
				};
			}
			return {...state};
		case types.UPDATE_SIGNOFF_ALL_DOCUMENTS:
			let newevidencesSignOff = JSON.parse(JSON.stringify(state.evidences));
			let updatedEvidences = newevidencesSignOff.map((evidence) => {
				if (evidence.documentTypeId !== documentTypes.PAPERPROFILE) {
					var updateEvidence = evidence;
					updateEvidence.isPrepRevSignOff = action.approvalType;
				}
				return evidence;
			});
			return {
				...state,
				evidences: updatedEvidences,
				selectedBulkSignOffOption: action.selectedOptionValue
			};
		case types.UPDATE_SIGNOFF_GIVEN_DOCUMENTS:
			let existingEvidences = JSON.parse(JSON.stringify(state.evidences));
			let updatedEvidencesWithSignOff = existingEvidences.map((evidence) => {
				if (
					evidence.documentTypeId !== documentTypes.PAPERPROFILE &&
					_.includes(action.documentIds, evidence.documentId)
				) {
					return {
						...evidence,
						isPrepRevSignOff: action.approvalType
					};
				} else {
					return evidence;
				}
			});
			return {
				...state,
				evidences: updatedEvidencesWithSignOff
			};
		case types.RESET_SIGN_OFFS_FOR_EVIDENCES:
			let existingEvidencesDetails = JSON.parse(JSON.stringify(state.evidences));
			let updatedEvidencesDetails = existingEvidencesDetails?.map((evidence) => {
				return {
					...evidence,
					isPrepRevSignOff: null
				};
			});
			return {
				...state,
				evidences: updatedEvidencesDetails ? updatedEvidencesDetails : null,
				isEPSignOffRequired: state.initialIsEPSignOffRequired,
				isEQRSignOffRequired: state.initialIsEQRSignOffRequired,
				isEPSignOffUserRequired: state.initialIsEPSignOffUserRequired,
				isEQRSignOffUserRequired: state.initialIsEQRSignOffUserRequired,
				selectedBulkSignOffOption: undefined
			};
		case types.ASSOCIATE_TASK_DOCUMENTS:
			// Scenario: User might upload document to another task and can navigate to another task
			// below condition will check if the user is in the task to which the association is being performed
			// action.meta.api.data.TaskId is the task id to which the association is being performed
			// state.taskId is the task which the user is currently viewing.
			// return the existing state if the user is in a different task.
			if (action.meta.api.data.TaskId !== state.taskId || action.error) {
				return state;
			}
			if (action.response && action.response.isDocumentNameAlreadyExists === true) {
				return state;
			}
			let categoryName = action.meta.api.data.parentName;
			if (categoryName.toLowerCase() !== 'evidences') {
				return state;
			}

			if (categoryName && state[categoryName]) {
				if (action.meta.api.data.operationType === 1) {
					let newState = state[categoryName].filter(
						(doc) =>
							doc.documentName + '.' + doc.fileExt != action.response.documentName + '.' + action.response.fileExt
					);

					const updatedState =
						action.response.documentName && action.response.fileExt ? [...newState, action.response] : newState;

					let finalUpdatedState = {
						[categoryName]: updatedState,
						enableHandOff: true,
						// will use signoff list to check if mark complete should enable or disabled
						enableCompleteButton: undefined
					};

					if (categoryName.toLowerCase() === 'evidences') {
						finalUpdatedState = Object.assign({}, finalUpdatedState, {
							initialEvidenceCollection: [...updatedState]
						});
					}

					return Object.assign({}, state, finalUpdatedState);
					//	return state;
				} else {
					//TODO: Operation type 2 for unaasociate
					// for unassociate we can use document id
					const updatedState =
						state[categoryName] &&
						state[categoryName].filter((doc) => doc.documentId != action.meta.api.data.DocumentId);

					let finalUpdatedState = {
						[categoryName]: updatedState
					};

					if (categoryName.toLowerCase() === 'evidences') {
						finalUpdatedState = Object.assign({}, finalUpdatedState, {
							initialEvidenceCollection: [...updatedState]
						});
					}

					return Object.assign({}, state, finalUpdatedState);
				}
			}
			return state;
		case types.ADD_APPROVAL_FOR_TASK:
			let newApprovalState = _.cloneDeep(state);
			if (_.isEmpty(newApprovalState)) {
				return state;
			}
			let addapprovalDoc = newApprovalState.evidences.find((doc) => doc.documentId === action.meta.api.data.documentId);
			if (!addapprovalDoc) {
				return state;
			}
			addapprovalDoc.isSignedOff = true;
			addapprovalDoc.signOffs
				? addapprovalDoc.signOffs.push(action.response)
				: (addapprovalDoc.signOffs = [action.response]);
			return Object.assign({}, state, newApprovalState);
		case types.DELETE_APPROVAL_FOR_TASK:
			let removeApprovalState = _.cloneDeep(state);
			if (_.isEmpty(removeApprovalState)) {
				return state;
			}
			let removeapprovalDoc = removeApprovalState.evidences.find(
				(doc) => doc.documentId === action.meta.api.data.documentId
			);
			if (!removeapprovalDoc) {
				return state;
			}
			removeapprovalDoc.signOffs = removeapprovalDoc.signOffs.filter(
				(signoff) => signoff.id !== action.meta.api.data.approvalId
			);
			// Do we have any signoffs on the document from the logged in user?
			let doesLoggedInUserHaveAnySignoffs = removeapprovalDoc.signOffs.some(
				(signoff) => signoff.approvalUserId === state.loggedInUserId
			);
			removeapprovalDoc.isSignedOff = doesLoggedInUserHaveAnySignoffs ? true : false;
			return Object.assign({}, state, removeApprovalState);

		case types.UPDATE_DOCUMENT_LIST_BY_ID: {
			let newEvidences = state.evidences?.map((evidence) => {
				if (evidence.documentId == action.documentId) {
					return {
						...evidence,
						...action.payload
					};
				}
				return evidence;
			});
			return {
				...state,
				evidences: newEvidences,
				initialEvidenceCollection: newEvidences
			};
		}
		case types.GET_DOCUMENT_BY_ID: {
			if (!_.isUndefined(state.evidences)) {
				const evidenceFound = _.find(state?.evidences, (value) => value.documentId === action.response?.id);
				let allEvidences = [...state?.evidences];
				let documentToBeAdded = action.response;
				if (!evidenceFound) {
					let uploadedEvidence =
						action.response && action.response.id
							? constructEvidenceForUploadDocument(documentToBeAdded, 'approvals')
							: null;
					uploadedEvidence && allEvidences.push(uploadedEvidence);
					return {
						...state,
						evidences: allEvidences,
						initialEvidenceCollection: allEvidences
					};
				}
			}

			return state;
		}
		case types.DELETE_DOCUMENT_BY_ID: {
			if (action.error) {
				return state;
			}
			if (action.documentId && !_.isUndefined(state.evidences)) {
				const evidencesFound = [...state.evidences];
				const filteredEvidences = _.filter(evidencesFound, (value) => value.documentId !== action.documentId);
				return {
					...state,
					evidences: filteredEvidences,
					initialEvidenceCollection: filteredEvidences
				};
			}
			return state;
		}
		case types.CLEAR_HANDSOFF_TASK_DOCUMENTS:
			return {};
		case types.RESET_TASK_ATTRIBUTES:
			return {
				...state,
				initialEvidenceCollection: null,
				apiLoaded: false
			};
		default:
			return state;
	}
}

function constructEvidenceList(action, state, key) {
	let evidenceList = [];
	for (let i = 0; i < action.response.data.length; i++) {
		let document = action.response.data[i];
		let newDocument = constructEvidenceForUploadDocument(document, key);
		evidenceList.push(newDocument);
	}
	return evidenceList;
}

function constructEvidenceForUploadDocument(document, key) {
	let newDocument = {
		documentId: document.id,
		documentName: document.documentName,
		fileExt: document.fileExt,
		documentTypeId: document.documentTypeId,
		signOffs: document[key],
		isShared: document.isShared,
		hasComments: document.hasComments,
		hasHiddenSheets: document.hasHiddenSheets,
		hasHighlights: document.hasHighlights,
		hasTaskSystemAssociated: document.hasTaskSystemAssociated,
		sourceEngagementId: document.sourceEngagementId ? document.sourceEngagementId : document.engagementId,
		isPrepRevSignOff: null,
		isEPSignoffRequired: document.isEPSignoffRequired,
		isEPSignoffUserRequired: document.isEPSignoffUserRequired,
		isEQRSignoffRequired: document.isEQRSignoffRequired,
		isEQRSignoffUserRequired: document.isEQRSignoffUserRequired
	};
	return newDocument;
}
